export const initialObjectiveTopics = [
  {
    id: 1,
    title: 'General Appearance'
  },
  {
    id: 2,
    title: 'Vital Signs'
  },
  {
    id: 3,
    title: 'Cardiovascular'
  },
  {
    id: 4,
    title: 'Respiratory'
  },
  {
    id: 5,
    title: 'Abdominal Exam'
  },
  {
    id: 6,
    title: 'Musculoskeletal'
  },
  {
    id: 7,
    title: 'Neurological'
  },
  {
    id: 8,
    title: 'Skin'
  },
  {
    id: 9,
    title: 'HEENT'
  }
];

export const initialObjectiveTemplateText = {
  1: [
    {
      id: 1,
      text:
        'Patient is alert, awake and oriented.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient appears well developed and well nourished.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient is in no acute distress.',
      checked: false
    }
  ],

  2: [
    {
      id: 1,
      text:
        'Vital signs reviewed and within normal limits.',
      checked: false
    },
    {
      id: 2,
      text:
        'Blood pressure is within normal range.',
      checked: false
    }
  ],

  3: [
    {
      id: 1,
      text:
        'Regular rate and rhythm.',
      checked: false
    },
    {
      id: 2,
      text:
        'No murmurs, rubs or gallops noted.',
      checked: false
    }
  ],

  4: [
    {
      id: 1,
      text:
        'Lungs are clear to auscultation bilaterally.',
      checked: false
    },
    {
      id: 2,
      text:
        'No wheezing, rales or rhonchi noted.',
      checked: false
    }
  ]
};